<a #topOfPage id="topOfPage"></a>
<div class="page-content" page-content >

  <prism-ui-heading
    font-size="lg"
    font-weight="regular"
    key-id="coverage-title"
    is-uppercase="false"
    variant="default"
    >{{formSection?.title}}
  </prism-ui-heading>

  <form id="coverageForm" [formGroup]="coverageForm" #formDirective="ngForm" (ngSubmit)="onSubmit()">
    <prism-ui-container key-id="page-content-container">
      <div class="row">
        <div class="alignTooltips">
          <prism-ui-copy
            key-id="selectCoverageKey"
            >
            <label>{{selectCoverageElement?.label}}</label>
          </prism-ui-copy>
          <div class="toolTipLeftPadding">
            <prism-ui-icon-button
              expanded="false"
              has-tooltip="true"
              icon-name="circle-info"
              is-inactive="false"
              is-waiting="false"
              key-id="eeoi-tooltip-wizard-coverage"
              label="{{selectCoverageToolTipDescription}}"
              size="small"
              [tooltipPosition]="coverageTooltipPosition"
              type="button"
              variant="tertiary"
              >
              <div class="coverageTooltipWidth coverageTooltipPadding">
                <prism-ui-copy key-id="coverageTooltip">{{selectCoverageToolTipDescription}}</prism-ui-copy>
              </div>
            </prism-ui-icon-button>
          </div>
        </div>
      </div>
      <prism-ui-form-field-select
        key-id="coveragesKey"
        form-field-items-count="1"
        [isValid]="checkboxFormValid"
        >
        <span slot="error">{{ coverageElement?.error }}</span>

      </prism-ui-form-field-select>
      @for (p of products; track p; let  i = $index) {
        <div class="container">
          <div class="item columnOne">
            <prism-ui-checkbox
              slot="input-{{ i + 1 }}"
              [labelText]="p.productName"
              [keyId]="p.key"
              ngDefaultControl
              formControlName="{{ i }}"
              [formGroup]="coverageForm"
              [isValid]="checkboxFormValid"
              [checked]="coverageForm.get(p.key).value"
              (prismUiCheckboxOnChange)="checkboxChecked($event, p.key)"
              >
            </prism-ui-checkbox>
          </div>
          <div class="mobilePadding"></div>
          @if (coverageForm.get(p.key).value === true) {
            @if (p.productLine === 'LIFE') {
              @if (p.productSchedule === 'both' ) {
                <app-life-schedule-radio [product]="p" [parentForm]="coverageForm"></app-life-schedule-radio>
              }
              @if (p.productSchedule.toUpperCase() === 'DOLLAR' ) {
                <app-life-schedule-dollar [product]="p" [parentForm]="coverageForm"></app-life-schedule-dollar>
              }
              @if (p.productSchedule.toUpperCase() === 'SALARY' ||  p.productSchedule.toUpperCase() === 'MULTIPLEOFSALARY') {
                <app-life-schedule-salary [product]="p" [parentForm]="coverageForm"></app-life-schedule-salary>
              }
            }
            @if (p.productLine === 'LTD' || p.productLine === 'STD' ) {
              @if (p.subProducts) {
                @if (p.subProducts.length > 1) {
                  <app-disability-radio [product]="p" [parentForm]="coverageForm"></app-disability-radio>
                }
              }
            }
          }
        </div>
      }
    </prism-ui-container>
    <div class="center continueCancelButtonPadding">
      @if (isEditFromReview) {
        <prism-ui-button-group
          key-id="coverage-edit-button-group"
          buttons-count="2"
          spacing="default"
          class="editActionButtons"
        >
          <prism-ui-button
            slot="1"
            button-width="full"
            key-id="back-button"
            size="md"
            variant="secondary"
            type="button"
            is-icon-right-aligned="false"
            [attr.is-inactive]="isSavingEdit ? 'true' : null"
            (click)="goBack()"
          >Back</prism-ui-button>
          <prism-ui-button
            slot="2"
            button-width="full"
            key-id="save-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            [attr.is-waiting]="isSavingEdit ? 'true' : null"
            [attr.is-inactive]="isSavingEdit ? 'true' : null"
            (click)="saveAndGoToReview()"
          >Save</prism-ui-button>
        </prism-ui-button-group>
      } @else {
        <app-continue-cancel (cancelEmitter)="onCancel()"></app-continue-cancel>
      }
    </div>
  </form>
</div>

<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{modalContentHeading}}</prism-ui-heading
    >
    <prism-ui-copy
      slot="modal-body"
      key-id="cancel-modal"
      >
      {{modalContentBody}}
    </prism-ui-copy>
    <div slot="modal-footer">
      <div class="modalButtonStyling">
        <prism-ui-button
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('prism-ui-modal-cancel-modal')"
        >Cancel</prism-ui-button>
        <prism-ui-button class="leftPaddingSmall"
          button-width="full"
          key-id="continue-button"
          size="md"
          variant="primary"
          type="button"
          is-icon-right-aligned="false"
          (click)="leaveAnyway()"
        >Leave Anyway</prism-ui-button>
      </div>
    </div>
  </prism-ui-modal>
